/**
 * group-name.js
 */

import React from 'react';
import makeStyles from '@mui/styles/makeStyles';


const useStyles = makeStyles(theme => ({
  groupName: {
    overflow: 'hidden',
    '& .name': {
      marginRight: theme.spacing(1),
      overflow: 'hidden',
      textOverflow: 'ellipsis',
    }
  }
}));


export default function GroupName(props) {
  const { name, decorators } = props;
  const classes = useStyles();

  return (
    <div className={`flex-hc ${classes.groupName}`}>
      <div className='name' title={name}>{name}</div>
      {decorators}
    </div>
  )
}